module.exports = __webpack_public_path__ + "img/20.564c5bb7.svg";